import * as Immutable from 'immutable';
import { OrderedMap } from 'immutable';
import { MapLayersManagerValue } from 'providers/MapLayersManagerProvider';
import React, { useEffect } from 'react';
import { MappedSheetVersion } from 'records/MappedSheetVersion';
import { Sheet, SheetId } from 'records/Sheet';
import { SheetVersion } from 'records/SheetVersion';
import LayerListItem from './LayerListItem';

const getSheetVersionFromSheets = (
  pageid: string,
  sheets: OrderedMap<SheetId, Sheet>
): SheetVersion => {
  return (
    sheets
      .valueSeq()
      .flatMap((sheet) => sheet.versions)
      .find((sheet) => sheet.pageid === pageid) || new SheetVersion()
  );
};

type LayerListProps = {
  allowItemEdit: boolean;
  saveVisibility: (visible: boolean, pageId: string) => void;
  mapLayerContext: MapLayersManagerValue;
  visibleLayers: Immutable.Set<string>;
};

const LayerList: React.FC<LayerListProps> = ({
  allowItemEdit,
  mapLayerContext,
  saveVisibility,
  visibleLayers,
}: LayerListProps) => {
  const {
    mappedSheetVersions,
    sheets,
    visibleMappedSheetVersions,
    queriedMappedSheets,
    setVisibleMappedSheetVersions,
  } = mapLayerContext;

  useEffect(() => {
    if (visibleLayers.size) {
      const queryToDisplay = queriedMappedSheets.filter((x) =>
        visibleLayers.contains(x)
      );
      if (queryToDisplay.size) {
        const queriedSheetsThatAreVisibleRightNow = visibleLayers.filter((x) =>
          queriedMappedSheets.contains(x)
        );
        const displayThisMerge =
          queriedSheetsThatAreVisibleRightNow.merge(queryToDisplay);
        setVisibleMappedSheetVersions(displayThisMerge);
      } else {
        setVisibleMappedSheetVersions(Immutable.Set<string>());
      }
    }
  }, [queriedMappedSheets]);

  const searchedMappedSheets = queriedMappedSheets
    .map(
      (id: string): MappedSheetVersion =>
        mappedSheetVersions.get(id, new MappedSheetVersion())
    )
    .filter(
      (mappedSheet: MappedSheetVersion): boolean => mappedSheet.pageid !== ''
    );

  return (
    <ul className="grow-1 oa p0 m0">
      {searchedMappedSheets.map(({ pageid }) => {
        const sheetVersion = getSheetVersionFromSheets(pageid, sheets);
        return (
          <LayerListItem
            key={pageid}
            allowItemEdit={allowItemEdit}
            sheetVersion={sheetVersion}
            visible={visibleMappedSheetVersions.has(pageid)}
            onVisibilityChange={(visible: boolean) =>
              saveVisibility(visible, pageid)
            }
          />
        );
      })}
    </ul>
  );
};

export default LayerList;
